module.exports = __webpack_public_path__ + "img/car-logo.55b1cf95.svg";